// table widget
ht.declare('div.tableWidgetOuter', function () {
  $(this).tableWidget();
});
